export const eyeoptions = [
	{ value: 'Bionic', label: 'Bionic', parm: 'eyes' },
	{ value: 'Blue', label: 'Blue', parm: 'eyes' },
	{ value: 'Bright', label: 'Bright', parm: 'eyes' },
	{ value: 'Brown', label: 'Brown', parm: 'eyes' },
	{ value: 'Cyber', label: 'Cyber', parm: 'eyes' },
	{ value: 'Diamond', label: 'Diamond', parm: 'eyes' },
	{ value: 'Eth', label: 'Eth', parm: 'eyes' },
	{ value: 'Eye Patch', label: 'Eye Patch', parm: 'eyes' },
	{ value: 'Laser Eyes Blue', label: 'Laser Eyes Blue', parm: 'eyes' },
	{ value: 'Laser Eyes', label: 'Laser Eyes', parm: 'eyes' },
	{ value: 'Matrix', label: 'Matrix', parm: 'eyes' },
	{ value: 'Sad', label: 'Sad', parm: 'eyes' },
	{ value: 'Stoned', label: 'Stoned', parm: 'eyes' },
];